module.exports = __webpack_public_path__ + "static/img/victim-kids-1.87986dbc.png";